// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.change-password-wrapper {
  display: grid;
  gap: 1rem;
  justify-items: center;
}
.change-password-wrapper .header {
  width: 100%;
  display: grid;
  grid-template-columns: 1fr auto;
  text-align: center;
}
.change-password-wrapper .header .mat-card-header-text,
.change-password-wrapper .header .title {
  justify-self: center;
}
.change-password-wrapper .input-fields {
  display: grid;
  min-width: 20vw;
}
.change-password-wrapper .card-content {
  display: grid;
  grid-template-columns: 1fr auto;
  gap: 1rem;
}
.change-password-wrapper .card-content .form {
  display: grid;
  gap: 1rem;
}
.change-password-wrapper .card-content .form .buttons {
  display: flex;
  justify-content: end;
  gap: 0.25rem;
}
.change-password-wrapper .errors {
  display: grid;
  justify-items: center;
  color: var(--color-error);
  font-size: var(--font-size-large);
}`, "",{"version":3,"sources":["webpack://./src/app/components/change-password/change-password.component.scss"],"names":[],"mappings":"AAAA;EAEI,aAAA;EACA,SAAA;EACA,qBAAA;AAAJ;AAEI;EACI,WAAA;EACA,aAAA;EACA,+BAAA;EACA,kBAAA;AAAR;AAEQ;;EAEI,oBAAA;AAAZ;AAII;EACI,aAAA;EACA,eAAA;AAFR;AAKI;EACI,aAAA;EACA,+BAAA;EACA,SAAA;AAHR;AAKQ;EACI,aAAA;EACA,SAAA;AAHZ;AAKY;EACI,aAAA;EACA,oBAAA;EACA,YAAA;AAHhB;AAQI;EACI,aAAA;EACA,qBAAA;EACA,yBAAA;EACA,iCAAA;AANR","sourcesContent":[".change-password-wrapper {\n\n    display: grid;\n    gap: 1rem;\n    justify-items: center;\n\n    .header {\n        width: 100%;\n        display: grid;\n        grid-template-columns: 1fr auto;\n        text-align: center;\n\n        .mat-card-header-text,\n        .title {\n            justify-self: center\n        }\n    }\n\n    .input-fields {\n        display: grid;\n        min-width: 20vw;\n    }\n\n    .card-content {\n        display: grid;\n        grid-template-columns: 1fr auto;\n        gap: 1rem;\n\n        .form {\n            display: grid;\n            gap: 1rem;\n\n            .buttons {\n                display: flex;\n                justify-content: end;\n                gap: 0.25rem;\n            }\n        }\n    }\n\n    .errors {\n        display: grid;\n        justify-items: center;\n        color: var(--color-error);\n        font-size: var(--font-size-large);\n    }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
